import { type Location, useSearchParams } from "react-router-dom";

const RETURN_TO_PARAM = "return-to";

/**
 * @return `goTo` with a param that sends the user back to `returnTo` afterwards
 */
export function pathWithReturn(goTo: string, returnTo: Location) {
  const params = new URLSearchParams({ [RETURN_TO_PARAM]: returnTo.pathname + returnTo.search });

  return `${goTo}?${params}`;
}

/**
 * @return the value of the return-to param if it exists and points inside the app
 */
export function useReturnTo() {
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get(RETURN_TO_PARAM);

  // Only same-origin relative paths are honoured so the login page cannot be used as an open
  // redirect. Resolving against the origin catches protocol-relative (`//host`) and backslash
  // (`/\host`) forms that a plain prefix check misses.
  if (!returnTo?.startsWith("/")) {
    return undefined;
  }

  const url = new URL(returnTo, window.location.origin);

  if (url.origin !== window.location.origin) {
    return undefined;
  }

  return url.pathname + url.search;
}
